const Form041SC = {
    stepName: {
        ImportantNotes: "重要事项",
        RegistrationAs: "注册类型",
        PersonalParticulars: "个人资料",
        ChildCareTraining: "幼儿工作训练",
        ChildCareExperience: "幼儿工作经验",
        Annex: "附件",
        Confirmation: "确认",
    },
    ChildrenAgeOption: {},
    FirstAidTrainingOption: {},
    dateOfResignationOptions: {
        yes: "是",
        no: "否",
    },
    toolTip: {
        course: "＊只提供课程的英文名称。",
    },
    importantNotes: {
        p_title: "個人資料收集聲明",

        p_title_one: "<u>收集個人資料的目的</u>",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_a: "就幼兒中心職員註冊申請，辦理有關處理、核實及查證的事務；",
        p1_b: "就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
        p1_c: "為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
        p1_d: "辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        p1_e: "辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
        p1_f: "辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
        p1_g: "辦理有關施行及強制執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 (即《幼兒服務規例》(香港法例第243A章)的事務",
        p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",

        p_title_two: "<u>可獲轉移資料者</u>",
        p3: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p3_a: "政府其他政策局及部門，包括社會福利署，以用於上文第1段所述的用途；",
        p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        p3_c: "受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，以用於上文第1段所述的用途；",
        p3_d: "你曾就披露個人資料給予訂明同意；以及",
        p3_e: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        p_title_three: "<u>查閱個人資料</u>",
        p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 ",
    },
    notes: {
        pographyOne:
            "1.根据《幼儿服务规例》第3(1)(a)或/及 (b)条，申请人须成功完成经社会福利署署长认可的训練课程，方才符合注册资格。有关符合注册幼儿工作员和幼儿中心主管的认可课程，请分别參考附錄I和附錄II。",
        pographyTwo:
            "2.申请人须把已填妥的申请表（请确保已于申请表第1页贴妥照片）寄回或亲身提交至香港太古城太古湾道14号6楼602室教育局幼稚园及幼儿中心聯合办事处（本办事处）办理，并附上下列文件：",
        pographyTwo_a: "a）身份证或护照副本；",
        pographyTwo_b: "b）一式三张背后写上申请人姓名的证件照片；",
        pographyTwo_c:
            "c）申请人的幼儿工作训練证书和/或其他幼儿工作训練证明文件副本。",
        pographyThree:
            "3.请确保已为邮件支付足够邮资。邮资不足的邮件，一律将由香港邮政处理。",
        pographyFour: "4.请勿将递交的文件钉在一起。",
        pographyFive:
            "5.申请人一般须亲身到本办事处与负责人员会面，并提供上述第（1）项所提及文件的正本，以供核实提交的副本。",
        pographySix:
            "6.申请人的姓名、注册号码、注册日期将根据《幼儿服务规例》第3条给公众人士查阅，以证实申请人具备上述法例规定的注册资格。",
        pographySeven: "7.如有查询，请致电本办事处，电话：31072197。",
        termsConditions: "本人已阅读、理解并同意上述条款及细则。",
        statement: "声明",
        typeHeader: "申请注册为",
        personalData: "提供／处理个人资料",
        personalParticulars: "个人资料",
        childCareTraining: "幼儿工作训练",
        childCareExperience: "幼儿工作经验（包括现时工作）",
        idAnnex: "身份证或护照副本",
        photograph: "申请人的证件照片",
        training: "申请人的幼儿工作训練证书和／或其他幼儿工作训練证明文件副本",
    },
    otherNotes: {
        pographyOne:
            "1.申请人所提供的个人资料，会供本办事处作注册用途，包括但不限于监察及检讨注册程序、进行研究及调查，以及履行法定职责。向本办事处提供个人资料，纯属自愿。如申请人未能提供足够的个人资料，本办事处可能无法处理其申请。",
        pographyTwo:
            "2.申请人所提供的个人资料可因应上文第（1）项所提及的用途，或在申请人同意下，或在法例授权或规定须予披露的情况下，向政府各决策局／部门披露。",
        pographyThree:
            "3.申请人请确保所提供的资料正确无误。除了《个人资料〈私隐〉条例》规定的豁免范围之外，申请人有权就本办事处存有其个人资料提出查阅和改正要求。申请人亦可在缴付所需费用后，索取申请表内所填写的个人资料複本。如欲查阅或改正申请表内所填写的个人资料，请致电本办事处，电话：31072197。",
    },
    label: {
        registrationType: "申请注册为：",
        supervisor: "幼儿中心主管",
        childCareWorker: "幼儿工作员",
        title: "称谓",
        // titleOption: {
        //     mr: "先生",
        //     mrs: "太太",
        //     miss: "小姐",
        //     ms: "女士",
        // },
        nameEn: "姓名（英文）",
        nameCn: "姓名（中文）",
        documentType: "请选择证件类型",
        hKid: "身份证号码",
        passport: "护照号码",
        dateOfBirth: "出生日期",
        residentialAddress: "住址",
        telNo: "电话",
        dcTelNo: "日间联络／手提电话",
        emailAddress: "电邮地址",
        nameOfWorkingCentre: "现职学前机构名称",
        workingCentreAddress: "幼儿中心地址",
        telNoAddress: "电话",
        awardedBy: "提供课程学院",
        courseName: "课程名称",
        othersSpecify: "其他（请说明）",
        nameOfCentre: "学前机构或幼儿中心名称",
        postHeld: "职位",
        dateOfCommencement: "到职日期",
        dateOfResignation: "已离职",
        dateOfLeaving: "离职日期",
        ageRange: "所服务儿童的年龄组别",
        school: "香港教育学院",
        schoolCourseName: "幼儿教育高级文凭课程",
        popMessage: "本课程同样适用于CCS和CCW,你想同时申请CCS和CCW吗?",
        yes: "是",
        no: "否",
    },
    errorMsg: {
        E01: "请输入正确格式.",
        E02: "请输入有效值",
        E03: "请至少在身份证号码和护照号码之间填一个",
        E04: "请至少在{{fieldOne}}和{{fieldTwo}}之间填一个",
        E0116: "可输入的最大长度:",
        E0117: "可输入的最小长度:",
        E05: "请至少输入一个项目",
        ccsAndccwRequired:
            "如欲同时申请注册成为幼儿工作员及幼儿中心主管，申请人须完成符合注册幼儿工作员及幼儿中心主管的相关认可课程。",
    },
};
export default Form041SC;
